import { createAsyncThunk } from "@reduxjs/toolkit";
import { taskManagementGetTasksThunk } from "./taskManagementGetTasksThunk";
import { openDrawerForTaskByIdThunk } from "../task-drawer-openers/openDrawerForTaskByIdThunk";
import { tasksListDataByIdSelector } from "../../selectors/data/tasksListDataByIdSelector";
import { setTaskManagementViewCompletedShown } from "../../taskManagementSlice";
import { getSavingsOpportunitiesThunk } from "@/store/savings-opportunities/thunks/data-getters/getSavingsOpportunitiesThunk";
import { getOrganisationUsersThunk } from "@/store/user/thunks/getOrganisationUsersThunk";
import { RootState } from "@/store/store";

export const initiateTaskManagementThunk = createAsyncThunk(
  "taskManagement/initiateTaskManagement",
  async (taskId: string | null, { dispatch, getState }) => {
    const state = getState() as RootState;

    dispatch(getOrganisationUsersThunk());
    dispatch(getSavingsOpportunitiesThunk());

    await dispatch(taskManagementGetTasksThunk());

    if (taskId) {
      const task = tasksListDataByIdSelector(state, taskId);

      if (task?.status?.category === "completed") {
        dispatch(setTaskManagementViewCompletedShown(true));
      }

      dispatch(openDrawerForTaskByIdThunk(taskId));
    }
  },
);
